import { useContext } from "react";
import ReplaySearchContext from "../ReplaySearchContext";
const useReplaySearchContext = () => useContext(ReplaySearchContext);
export default useReplaySearchContext;
